// versionService.js
export class VersionService {
    constructor() {
        this.currentVersion = "__VUE_APP_VERSION__" || "1.0.0";
        this.checkInterval = 5 * 60 * 1000; // 5 minutes
        this.intervalId = null;
    }

    async checkForUpdates() {
        try {
            const response = await fetch("/version.json?" + Date.now());
            const { version } = await response.json();
            console.log("Received version", version);

            if (version !== this.currentVersion) {
                this.notifyUserOfUpdate();
            }
        } catch (error) {
            console.warn("Version check failed:", error);
        }
    }

    notifyUserOfUpdate() {
        // Show notification to user
        if (confirm("A new version is available. Reload to update?")) {
            window.location.reload();
        }
    }

    startPolling() {
        console.log("Start polling version each ", this.checkInterval, "ms. Current version", this.currentVersion);
        // Clear any existing interval
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }

        // Start polling
        this.intervalId = setInterval(() => this.checkForUpdates(), this.checkInterval);

        // Also check immediately
        // this.checkForUpdates();
    }

    stopPolling() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }
}

// Create a singleton instance
export const versionService = new VersionService();
